<template>
  <v-card
    tile
    flat
    height="100%"
    style="position: relative"
    :style="{ 'background-color': '#e7e7e7' }"
    :class="`flexcard ma-0 pa-0`"
  >
    <!-- 헤더 START -->
    <rs-survey-header :themeColor="theme ? theme.color : null" :headerLogo="theme ? theme.headerLogo: null"></rs-survey-header>
    <v-progress-linear
    v-if="surveyResponse && surveyResponse.progressStatus == 'IN_PROGRESS'"
      :value="surveyResponse.progressRate"
      height="25"
      class="elevation-3"
    >
      <strong>{{ Math.ceil(surveyResponse.progressRate) }}%</strong>
    </v-progress-linear>
    <!-- 헤더 END -->
    <!-- 로딩 혹은 처리 중 표시 영역 START -->
    <v-overlay :value="loading" color="black" opacity="0.65">
      <rx-spinner
        spinnerType="CUBESHADOW"
        size="5rem"
        :message="$t('로딩중...')"
      >
      </rx-spinner>
    </v-overlay>
    <!-- 로딩 혹은 처리 중 표시 영역 END -->
    <!-- 메인 정보 영역 START -->
    <v-row justify="center">
      <v-col
        :class="`${$vuetify.breakpoint.smAndDown ? ' ma-2 col-12' : 'col-6'}`"
      >
        <v-fade-transition mode="out-in" origin="bottom center 0">
          <!-- 상태와 페이지를 조합한 key로 컴포넌트를 구분해 페이지 변경 시 새로 생성되도록 함 -->
          <component
            v-if="pageComp"
            :is="pageComp.component"
            :properties="pageComp.properties"
            @loading="(l) => (loading = l)"
            :rid="rid"
            :targetKey="targetKey"
            @next="nextPage"
            @previous="moveToPreviousPage"
            :key="`${surveyResponse.progressStatus}-${surveyResponse.currentPageId}`"
            :themeColor="theme.color"
          ></component>
        </v-fade-transition>
      </v-col>
    </v-row>
    <!-- 메인 정보 영역 END -->
    <!-- 설문 안내 박스 START (설문 진행 이외 설문 진행 안내 페이지 정보) -->
    <v-fade-transition mode="out-in" origin="bottom center 0">
      <rs-survey-info
        v-show="isError"
        :message="isError.messageDetail"
      ></rs-survey-info>
    </v-fade-transition>
    <!-- 설문 안내 박스 END -->
  </v-card>
</template>
<script>
import { v4 } from "uuid";
import { $getCurrentPage, $getSurveyTheme, $moveToPreviousPage } from "@/redsurvey/api/survey";
import RsSurveyHeader from "@/redsurvey/components/survey/RsSurveyHeader";
import RsSurveyInfo from "@/redsurvey/components/common/RsSurveyInfo";
export default {
  components: {
    RsSurveyHeader,
    RsSurveyInfo,
  },
  props: {
    surveyId: {
      type: Number,
      required: true,
    },
    // TODO: parameter t(surveyType은 현 기능에서 딱히 필요없어 보임 추후  삭제)
    // surveyType: {
    //   type: String,
    //   required: true,
    // },
    targetKey: {
      type: String,
    },
  },
  computed: {
    rid() {
      return localStorage.getItem("rsx:r");
    },
    infoMessage() {
      return null;
    },
  },
  data() {
    return {
      currentSurvey: {},
      survey: null,
      surveyResponse: null,
      isError: false,
      loading: false,
      pageComp: null,
      theme: null,
    };
  },
  methods: {
    async init() {
      /**
       * 초기화
       */

      // 0 . theme 설정 처리 
      await this.setSurveyTheme();
      // 1. 고유식별자 생성
      this.createRespondentId();
      // TODO: 2. 설문 테마 정보 취득 및 설정 (세션 스토리지 혹은 스토어에 저장.)

      // TODO: 3. 현재 설문 참여 페이지 정보 확인 후 이동
      this.moveCurrentPage();
    },
    nextPage(result) {
      if (result.surveyResponse.progressStatus == "COMPLETED") {
        this.pageComp = {
          component: () =>
            import("@/redsurvey/components/survey/RsSurveyCompleted"),
          properties: result,
        };
      } else {
        this.moveCurrentPage();
      }
    },
    async moveToPreviousPage() {
      this.loading = true;
      try {
        await $moveToPreviousPage(this.surveyId, {
          k: this.targetKey,
          r: this.rid,
        });
        await this.moveCurrentPage();
      } catch (e) {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      } finally {
        this.loading = false;
      }
    },
    async moveCurrentPage() {
      // TODO: 현재페이지 조회 후 이동 시키기
      const params = {
        k: this.targetKey,
        r: this.rid,
      };
      try {
        this.loading = true;
        const { data } = await $getCurrentPage(this.surveyId, params);
        const rst = data.result;
        this.survey = rst.survey;
        this.surveyResponse = rst.surveyResponse;

        switch (this.surveyResponse.progressStatus) {
          case "OPEN":
            this.pageComp = {
              component: () =>
                import("@/redsurvey/components/survey/RsSurveyStart"),
              properties: rst,
            };
            break;
          case "IN_PROGRESS":
            this.pageComp = {
              component: () =>
                import("@/redsurvey/components/survey/RsSurveyForm"),
              properties: rst,
            };
            break;
          case "WAIT_SUBMIT":
            this.pageComp = {
              component: () =>
                import("@/redsurvey/components/survey/RsSurveySubmit"),
              properties: rst,
            };
            break;
          default:
            break;
        }
        this.isError = false;
      } catch (e) {
        const err = e.response.data;
        this.isError = err;
        // TODO: 메시지 오류 별 처리
        // switch (err.messageCode) {
        //   case "404-1": // 존재하지 않는 설문조사입니다. (잘못된 페이지)
        //     this.$router.push(
        //       `${this.RX_PAGE.genUri(this.RX_PAGE.NOT_FOUND_PAGE)}`
        //     );
        //     break;
        //   case "400-1": // 진행중인 설문조사가 아닙니다.
        //     break;
        //   case "400-2": // 설문조사 대상자가 아닙니다.
        //     // this.$router.replace(
        //     //   `${this.RX_PAGE.genUri(this.RX_PAGE.NOT_FOUND_PAGE)}`
        //     // );
        //     break;
        //   case "400-3": // 이미 참여한 설문조사 입니다.
        //     break;
        //   default:
        //     // 기타 오류
        //     break;
        // }
      } finally {
        this.loading = false;
      }
    },
    createRespondentId() {
      /**
       * 설문 조사자 고유 식별자 생성 메소드
       */
      if (!localStorage.getItem("rsx:r")) {
        localStorage.setItem("rsx:r", v4());
      }
    },

    //설문테마 정보 
    async setSurveyTheme() {
      try {
        const {data} = await $getSurveyTheme(this.surveyId);
        this.theme = data.result;
        } catch (e) {
        const err = e.response.data;
        this.isError = err;
      }
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  // background-color: rgb(68, 89, 158);
}
.flexcard {
  display: flex;
  flex-direction: column;
}
// Add the css below if your card has a toolbar, and if your toolbar's height increases according to the flex display.
.flexcard .v-toolbar {
  flex: 0;
}
</style>